import { useEffect, useState } from 'react';
import apiClient from '../api/apiClient';
import styles from './BackendStatusBar.module.css';

const POLL_MS = 45_000;

export default function BackendStatusBar() {
  const [down, setDown] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const { data } = await apiClient.get('/health', { timeout: 8000 });
        if (cancelled) return;
        setDown(!data?.ok);
      } catch {
        if (cancelled) return;
        setDown(true);
      }
    };

    check();
    const id = window.setInterval(check, POLL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty('--backend-banner-height', down ? '40px' : '0px');
    return () => {
      document.documentElement.style.setProperty('--backend-banner-height', '0px');
    };
  }, [down]);

  if (!down) return null;

  return (
    <div className={styles.banner} role="status">
      <span className={styles.text}>
        Backend server is not reachable — booking, login, and live data may not work until it is
        back online.
      </span>
    </div>
  );
}
